module.exports = __webpack_public_path__ + "static/media/mansura_thumb.e705db05.webp";